import React from 'react'
import UtilityService from '../../services/UtillityServices/UtilityService'
import imgCard from '../../assets/img/orange-classroom.jpg';
import './HorizontalCourseCard.scss'
import { ROLES } from '../../model/roles';
import { TIPO_CORSO } from '../../model/tipoCorso';

const HorizontalCourseCard = ({course, userLoggedIn, selectedRole, onRemoveCourse, isContenutiAggiuntiviView, cardStyle, courseDesignerCorsi, partnerNewCorsi, isCreateUserView}) => {
  const imgSrc = course?.corso?.immagine_corso || imgCard;

  return (
    <div className={`card ${cardStyle} my-3 horizontalCourseCard py-2`}>
      <div className='d-flex justify-content-between'>
        <div className='d-flex gap-2'>
            <div className='align-self-center'>
                <img className='card-img' src={imgSrc} style={{height: '90px', width: '100px'}} alt='immagine corso' />
            </div>
            <div className='align-self-center card-content fs-6'>
              {course && (
              <span className='d-block'>{course?.corso?.denominazione}
              {
                course?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA && (
                  <>
                  {" - "}{course?.denominazione}{" - "}({course?.data_inizio ? UtilityService.formatDate(course?.data_inizio) : ""} - {course?.data_fine ? UtilityService.formatDate(course?.data_fine) : ""})
                  </>
                )
              }
              
              </span>
              )}
                { (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER) && selectedRole === "corsista" && (
                  <>
                  <span className='d-block'><b>Stato pagamento:</b> {UtilityService.getPaymentState(course?.stato_pagamento)}</span>
                  <span className='d-block'><b>Prezzo:</b> {course?.corso?.prezzo} €</span>
                  </>
                )
                }
                { (userLoggedIn?.role === ROLES.PARTNER) && selectedRole === "corsista" && (
                  <>
                  <span className='d-block'>{course?.pagamento_partner == "1" ? "Pagamento a proprio carico" : "Pagamento a carico del corsista"}</span>
                  <span className='d-block'>{course?.sconto_corsista == "1" ? `Sconto applicato	 : ${course?.sconto} €` :  "Sconto non applicato"}</span>
                  {
                    course?.sconto_corsista == "1" ? (
                      <span className='d-block'>Prezzo: <del>{course?.corso?.prezzo} €</del> {(course?.corso?.prezzo - course?.sconto).toFixed(2) > 0 ? (course?.corso?.prezzo - course?.sconto).toFixed(2) : 0} €</span>
                    ) : (
                      <span className='d-block'>Prezzo: {course?.corso?.prezzo} €</span>
                    )
                  }
                  </>
                )
                }
            </div>
        </div>
        {
          !isContenutiAggiuntiviView && (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER) && (
          <div className='align-self-center'>
          <i role='button' onClick={() => onRemoveCourse(course.id_classe)} className="bi bi-trash-fill me-4 text-danger fs-3"></i>
          </div>
          )
        }
        {
          !isContenutiAggiuntiviView && isCreateUserView && userLoggedIn?.role === ROLES.PARTNER && (
          <div className='align-self-center'>
          <i role='button' onClick={() => onRemoveCourse(course.id_classe)} className="bi bi-trash-fill me-4 text-danger fs-3"></i>
          </div>
          )
        }
        {
          !isContenutiAggiuntiviView && (userLoggedIn?.role === ROLES.PARTNER) && partnerNewCorsi?.some(corso => corso.id_classe === course.id_classe) && (
          <div className='align-self-center'>
          <i role='button' onClick={() => onRemoveCourse(course.id_classe)} className="bi bi-trash-fill me-4 text-danger fs-3"></i>
          </div>
          )
        }
        {
          !isContenutiAggiuntiviView && userLoggedIn?.role === ROLES.COURSE_DESIGNER && courseDesignerCorsi?.some(corso => corso.id_corso === course.id_corso) && (
          <div className='align-self-center'>
          <i role='button' onClick={() => onRemoveCourse(course.id_classe)} className="bi bi-trash-fill me-4 text-danger fs-3"></i>
          </div>
          )
        }
      </div>
    </div>
  )
}

export default HorizontalCourseCard